























import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";

import { api } from "@/store/modules/data";

import BarChart from "@/components/charts/BarChart";
import "chartjs-plugin-colorschemes";
import { calculateAverageProcessingTimeData } from "@/utils/DataTransformations";

@Component({
  components: {
    BarChart
  }
})
export default class MeasuresView extends Vue {
  chartJSOptions = {
    maintainAspectRatio: false,
    plugins: {
      colorschemes: {
        scheme: "brewer.SetOne9"
      }
    }
  };

  @Action(api.actions.loadData, { namespace: api.namespace })
  loadData!: () => Promise<void>;

  @Getter(api.getters.getRawData, {
    namespace: api.namespace
  })
  rawData!: any;

  get averageProcessingTimeData() {
    return calculateAverageProcessingTimeData(this.rawData);
  }

  mounted() {
    this.loadData();
  }
}
